// extracted by mini-css-extract-plugin
export default {"heading":"heading__MDUyZ","strong":"strong__YjkzM","h1":"h1__YTk5O","h2":"h2__YjIxY","h3":"h3__N2Q2M","h4":"h4__ODRjN","h5":"h5__OTQ4N","h6":"h6__MThmO"};